/**
 * Auth Cleanup Utility
 * 
 * Handles cleanup of sensitive data on logout and session expiry
 */

import { secureStorage } from './secureStorage';
import { devLog } from './secureLogger';

/**
 * Clear all user-specific data on logout
 */
export const clearUserData = () => {
  devLog('Clearing user data on logout');
  
  // Clear campaign data
  secureStorage.clearCampaignData();
  
  // Clear secure storage
  secureStorage.clearAll();
  
  // Clear any remaining sensitive keys
  const sensitiveKeys = [
    'authToken',
    'userSession',
    'userProfile',
    'paymentInfo',
    'draftData'
  ];
  
  sensitiveKeys.forEach(key => {
    localStorage.removeItem(key);
    sessionStorage.removeItem(key);
  });
};

/**
 * Initialize auth cleanup listeners
 */
export const initAuthCleanup = () => {
  // Listen for logout events
  window.addEventListener('logout', clearUserData);
  
  // Listen for storage events from other tabs
  window.addEventListener('storage', (e) => {
    if (e.key === 'logout' && e.newValue === 'true') {
      clearUserData();
      window.location.href = '/auth';
    }
  });
  
  // Clean expired items periodically (every 5 minutes)
  setInterval(() => {
    secureStorage.cleanExpired();
  }, 5 * 60 * 1000);
};
